import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EUserRole } from './entities/user.entity';
import { AuthService } from './services/auth.service/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit(): any {
    /*
    if (!['apps', 'booking', 'auth','second-opinion'].some(e => e === this.getPath())) {
      if (this.authService.isLogedIn()) {
        switch (this.authService.getCurrentUser()?.role || 0) {
          case EUserRole.DOCTOR:
            return this.router.navigate(['/doctor']);
          case EUserRole.DOCTOR_SECRETARY:
            return this.router.navigate(['/secretary']);
          case EUserRole.PHARMACIST:
            return this.router.navigate(['/pharmacist']);
          case EUserRole.BIOLOGIST:
            return this.router.navigate(['/biologist']);
          case EUserRole.RADIOLOGIST:
            return this.router.navigate(['/radiologist']);
            case EUserRole.CLINIQUE_ADMIN:
            return this.router.navigate(['/clinic']);
          case EUserRole.ADMIN:
            return this.router.navigate(['/backoffice']);
        }
      } else {
        this.router.navigate(['/auth/login']);
      }
    }
      */
  }

  public getPath(): string {
    return window.location.pathname.split("/").filter(e => e.trim() != '')[0]?.trim() || '';
  }
}
